/**
 * What Home's suggestion chips and the server's label writer share: the verb
 * each kind of suggestion opens with, and the one string form of a subject.
 *
 * @module homeSuggestionLabels
 */
import type { HomeSuggestionKind, HomeSuggestionSubject } from "@amoreg/contracts";

/** The imperative a suggestion opens with; the title label and the model's input both read it. */
export const SUGGESTION_VERB: Readonly<Record<HomeSuggestionKind, string>> = {
  finding: "Resolve",
  update: "Assess",
  workflow: "Fix",
  review: "Prepare",
};

/** `finding.assessment:<id>`, `update:<id>`, …: one key for matching, dedupe and storage. */
export function homeSuggestionSubjectKey(subject: HomeSuggestionSubject): string {
  const type = "source" in subject ? `${subject.kind}.${subject.source}` : subject.kind;
  return `${type}:${subject.id.toLowerCase()}`;
}
